/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';



export interface SchedulerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Execute a selected procedure
     * 
     * @param procedureName The name of the procedure to be executed.
     */
    executeProcedure(procedureName: string, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Update views
     * 
     * @param viewName The name of the view to be updated.
     */
    refreshView(viewName: string, extraHttpRequestParams?: any): Observable<string>;

}
